"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var formik_1 = require("formik");
var react_1 = __importStar(require("react"));
var __1 = require("../../../");
var context_1 = require("../../../../context");
var utils_1 = require("../../../../utils");
var Tabs_1 = require("../../../Tabs/Tabs");
var Fields_1 = require("../Fields");
exports.errorKeys = ['borough'];
var ProjectForm = function (_a) {
    var tabId = _a.tabId;
    var _b, _c;
    var _d = context_1.useSemantics(), trans = _d.trans, options = _d.options;
    var setTabError = Tabs_1.useTabsContext().setTabError;
    var errors = formik_1.useFormikContext().errors;
    react_1.useEffect(function () { return setTabError(tabId, utils_1.objectHasAnyKey(errors, exports.errorKeys, 'project.')); }, [errors]);
    return (react_1.default.createElement(__1.Card, { heading: trans('project:slhh::headings.details'), subHeading: trans('project:slhh::headings.project') },
        react_1.default.createElement(__1.FormControl, { errors: ((_b = errors.project) === null || _b === void 0 ? void 0 : _b.borough) || [], label: trans('project:slhh::labels.borough') },
            react_1.default.createElement(__1.Select, { width: "xs", name: "project.borough", options: {
                    bexley: trans('project:slhh::enum.borough.bexley'),
                    bromley: trans('project:slhh::enum.borough.bromley'),
                    croydon: trans('project:slhh::enum.borough.croydon'),
                    greenwich: trans('project:slhh::enum.borough.greenwich'),
                    kingston: trans('project:slhh::enum.borough.kingston'),
                    lambeth: trans('project:slhh::enum.borough.lambeth'),
                    lewisham: trans('project:slhh::enum.borough.lewisham'),
                    merton: trans('project:slhh::enum.borough.merton'),
                    richmond: trans('project:slhh::enum.borough.richmond'),
                    southwark: trans('project:slhh::enum.borough.southwark'),
                    sutton: trans('project:slhh::enum.borough.sutton'),
                    wandsworth: trans('project:slhh::enum.borough.wandsworth'),
                } })),
        react_1.default.createElement(__1.FormControl, { errors: (_c = errors.project) === null || _c === void 0 ? void 0 : _c.is_bget, label: trans('project:slhh::labels.is-bget') },
            react_1.default.createElement(__1.Select, { width: "xs", options: options.boolean(), name: "project.is_bget" })),
        react_1.default.createElement(Fields_1.ProjectServiceInput, null)));
};
exports.default = ProjectForm;
//# sourceMappingURL=ProjectForm.js.map